module.exports = __webpack_public_path__ + "static/media/wdiatt_image3.36056fa3.jpg";